export default __webpack_public_path__ + "static/media/DTEX-UC2-Seq5b-Reports-Digital-Powershell-Full.20fae83c.png";